import { getBaseUrl } from '../../common/getBaseUrl';
import { postData } from '../../common/getData';
import { createHeaders } from '../../common/lib/createHeaders';
import { ApiResponse } from '../../types/ApiResponse';
import { OrganisationsnummerInnehav } from '../model/ipm-innehav';

const port = '8557';
const path = '/api/innehav/v1/innehav';

export const getInnehav = (
  organisationsnummer: string,
  kundmarke?: string
): Promise<ApiResponse<OrganisationsnummerInnehav[]>> =>
  postData(
    getBaseUrl(path, port),
    {
      organisationsnummer: [organisationsnummer],
    },
    createHeaders('application/json', kundmarke)
  );

